import { render, staticRenderFns } from "./issuable_by_email.vue?vue&type=template&id=60eda3a8"
import script from "./issuable_by_email.vue?vue&type=script&lang=js"
export * from "./issuable_by_email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports